var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var PrimetimeAds = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'PrimetimeAds'
  },

  getResource: function () {
    return this.resource
  },

  getTitle: function () {
    return 'unknown'
  },

  getDuration: function () {
    return this.duration
  },

  getPosition: function () {
    if (!this.plugin.getAdapter().flags.isJoined) {
      return 'pre'
    } if (this.plugin.getAdapter().stopFired) {
      return 'post'
    }
    return 'mid'
  },

  getPlayhead: function () {
    return this.player.currentTime / 1000 // - this.player.localTime) / 1000) - this.plugin.getAdapter().acumAdTime + this.duration
  },

  /* getGivenBreaks: function () {
     return null
   }, */

  /* getBreaksTime: function () {
    return null // list of positions
  }, */

  getGivenAds: function () {
    return this.adListBreak.length
  },

  getAudioEnabled: function () {
    return this.player.volume > 0
  },

  // getIsSkippable: function () {},

  getIsFullscreen: function () {
    var contentPlayer = this.player.view.delegate._video
    if (contentPlayer && contentPlayer.clientWidth && contentPlayer.clientHeight) {
      return (window.innerHeight <= contentPlayer.clientHeight + 30 && window.innerWidth <= contentPlayer.clientWidth + 30)
    }
    return false
  },

  getIsVisible: function () {
    return youbora.Util.calculateAdViewability(this.player.view.delegate._video)
  },

  getCreativeId: function () {
    return this.creativeId
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    this.monitorPlayhead(true, false)

    var event = AdobePSDK.PSDKEventType
    // References
    this.references = []
    this.references[event.AD_BREAK_STARTED] = this.playListener.bind(this)
    this.references[event.AD_STARTED] = this.playListener.bind(this)
    this.references[event.AD_CLICK] = this.clickListener.bind(this)
    this.references[event.AD_BREAK_COMPLETED] = this.endedListener.bind(this)
    this.references[event.AD_BREAK_SKIPPED] = this.skippedListener.bind(this)
    this.references[event.AD_COMPLETED] = this.endedListener.bind(this)
    this.references[event.AD_PROGRESS] = this.progressListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  playListener: function (e) {
    this.adListBreak = e.adBreak.ads
    this.fireStart()
    this._quartileTimer = new youbora.Timer(this.sendQuartile.bind(this), 1000)
    this._quartileTimer.start()
  },

  endedListener: function (e) {
    this.fireStop({ adPlayhead: this.duration })
    this.resetValues()
  },

  skippedListener: function (e) {
    this.fireStop({ skipped: true })
    this.resetValues()
  },

  clickListener: function (e) {
    this.fireClick()
  },

  progressListener: function (e) {
    if (!this.flags.isJoined) {
      this.duration = e.ad.duration / 1000
      this.resource = e.ad.primaryAsset.resource.url
      this.plugin.getAdapter().acumAdTime += this.duration
      this.creativeId = e.ad.id
      this.fireJoin()
    }
  },

  sendQuartile: function () {
    var quartile = 0
    if (this.getPlayhead() > this.duration / 4) {
      if (!this.firstQuartile) {
        this.firstQuartile = true
        quartile = 1
      }
      if (this.getPlayhead() > this.duration / 2) {
        if (!this.secondQuartile) {
          this.secondQuartile = true
          quartile = 2
        }
        if (this.getPlayhead() > this.duration * 0.75) {
          if (!this.thirdQuartile) {
            this.thirdQuartile = true
            quartile = 3
          }
        }
      }
    }
    this.fireQuartile(quartile)
    if (quartile === 3) this._quartileTimer.stop()
  },

  resetValues: function () {
    this.duration = null
    this.initialPlayhead = null
    this.resource = null
    this.firstQuartile = false
    this.secondQuartile = false
    this.thirdQuartile = false
  }
})

module.exports = PrimetimeAds
